import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ProviderRegistration } from '../models/provider-registration.model';

@Injectable({
  providedIn: 'root'
})
export class ProviderRegistrationService {
  private readonly webhookUrl = 'https://beta-n8n.sillion.mx/webhook/0ac4cf54-36ca-4fdb-addb-78123fc9cb21';

  constructor(private http: HttpClient) {}

  /**
   * Registers a new provider by sending data to the webhook endpoint
   * @param providerData - The provider registration data
   * @returns Observable with the response from the webhook
   */
  registerProvider(providerData: ProviderRegistration): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });

    return this.http.post<any>(this.webhookUrl, providerData, { headers });
  }
}